import type { z } from 'zod'

// Distinct from a pre-send z.ZodError, so a caller can tell a request it built wrongly apart from a response the server shaped unexpectedly.
export class ResponseParseError extends Error {
  public override readonly cause: z.ZodError
  public readonly url: string

  public constructor(cause: z.ZodError, url: string) {
    super(`The response from ${url} could not be parsed.`)
    this.name = 'ResponseParseError'
    this.cause = cause
    this.url = url
  }
}
